export enum PaymentType {
  HomeAnalysis = 'HomeAnalysis',
  EnterpriseAnalysis = 'EnterpriseAnalysis',
  BusinessSubscription = 'BusinessSubscription',
  BusinessPlusSubscription = 'BusinessPlusSubscription',
}
